import React from "react";
import Button from "./Button";

export default function ModalButton(props) {
  return (
    <Button
      onClick={props.onClick}
      width={"30%"}
      cursor={"pointer"}
      padding={"10px"}
      backgroundColor={"rgb(33, 42, 65)"}
      color={"#FFF"}
      borderRadius={"8px"}
      fontWeight={"bold"}
      margin={"5px"}
      fontSize={"1.1rem"}
    >
      {props.children}
    </Button>
  );
}
